import React from "react";
import { render } from "react-dom";
import Gfyw from "../components/gfyw/gfyw.jsx";
import ajaxError from "../helpers/ajaxError";
import page from "page";
import log from "../helpers/log";

import gameFilter from "../helpers/gameFilter";

export default function() {
	const location = window.location.href.split("/")[
		window.location.href.split("/").length - 1
	];

	$.ajax({
		method: "GET",
		url: links.api.games,
		data: { section: "gfyw" }
	})
		.done(data => {
			const { meta } = data;
			paginationData = {
				totalPages: meta.totalPages,
				page: meta.page,
				section: "gfyw",
				sortBy: "page",
				parsed: false,
				games_related: "false",
				disable_ranking: "false",
				first: location
			};

			render(
				<Gfyw {...data} />,
				document.getElementsByClassName("gfyw-container")[0]
			);

			page("/" + location + "/", gameFilter);
			page("/" + location + "/:page", gameFilter);

			page();
		})
		.fail(ajaxError)
		.always(_ => {
			$(".gfyw-container")
				.find(".Loading")
				.remove();
		});
}
